function getBaseURL() {
  if (process.env.NODE_ENV === 'development') {
    return 'http://beacon-api.joinlede.local:8002';
  } else if (document.location.hostname === 'analytics.allegrocdp.com') {
    return 'https://analytics-api.allegrocdp.com';
  }
  return 'https://api.ledebeacon.com';
}

export default getBaseURL();